import React, { Component } from 'react';

class Informations extends Component {
  render() {
    let phone =
      this.props.client.phone == null
        ? []
        : this.props.client.phone
            .split(';')
            .map((item) => item.trim())
            .filter(function (e) {
              return e !== null && e !== "";
            })
            .join(' / ');

    let phone_mobile =
      this.props.client.phone_mobile == null
        ? []
        : this.props.client.phone_mobile
            .split(';')
            .map((item) => item.trim())
            .filter(function (e) {
              return e !== null && e !== "";
            })
            .join(' / ');

    let email =
      this.props.client.email == null
        ? []
        : this.props.client.email
            .split(';')
            .map((item) => item.trim())
            .filter(function (e) {
              return e !== null && e !== "";
            })
            .join(' / ');

    let birthdate = null;
    if (this.props.client.birthdate != null) {
      birthdate = new Date(this.props.client.birthdate * 1000);
      birthdate = ('0' + birthdate.getDate()).slice(-2) + '/' + ('0' + (birthdate.getMonth() + 1)).slice(-2) + '/' + birthdate.getFullYear();
    }

    let social_networks =
      this.props.client.social_networks == null
        ? []
        : this.props.client.social_networks
            .split(';')
            .map((item) => item.trim())
            .filter(function (e) {
              return e !== null && e !== "";
            })
            .join(' / ');

    let children =
      this.props.client.children == null
        ? []
        : this.props.client.children
            .split(';')
            .map((item) => item.trim())
            .filter(function (e) {
              return e !== null && e !== "";
            })
            .join(' / ');

    let criterias =
      this.props.client.criterias == null
        ? []
        : this.props.client.criterias
            .split(';')
            .map((item) => item.trim())
            .filter(function (e) {
              return e !== null && e !== "";
            })
            .join(' / ');

    let useful_equipements =
      this.props.client.useful_equipements == null
        ? []
        : this.props.client.useful_equipements
            .split(';')
            .map((item) => item.trim())
            .filter(function (e) {
              return e !== null && e !== "";
            })
            .join(' / ');

    let useless_equipements =
      this.props.client.useless_equipements == null
        ? []
        : this.props.client.useless_equipements
            .split(';')
            .map((item) => item.trim())
            .filter(function (e) {
              return e !== null && e !== "";
            })
            .join(' / ');

    let cars =
      this.props.cars == null
        ? []
        : this.props.cars.map((c) => {
            return (
              <div key={c.id}>
                {c.use &&
                  c.replacement_interested &&
                  c.place_purchase &&
                  c.main_user &&
                  c.decision_maker &&
                  c.funding &&
                  c.avg_km &&
                  c.duration &&
                  c.budget && (
                    <div className='m-2'>
                      <span className='h6 text-secondary mr-1'>
                        {c.brand} {c.model}
                      </span>
                      <span>
                        <ul>
                          {c.use && <li>Usage {c.use}</li>}
                          {c.replacement_interested && (
                            <li>
                              {' '}
                              {c.replacement_interested == 0 ? 'Pas intéressé' : 'Intéressé'} par un véhicule de remplacement{' '}
                              {c.replacement_same == 1 ? 'identique' : ''}
                            </li>
                          )}
                          {c.place_purchase && <li>Acheté à {c.place_purchase}</li>}
                          {c.main_user && <li>Utilisateur principal : {c.main_user}</li>}
                          {c.payer && <li>Payeur/Financeur : {c.payer}</li>}
                          {c.decision_maker && <li>Décisionnaire d'achat : {c.decision_maker}</li>}
                          {c.funding && <li>Financement : {c.funding}</li>}
                          {c.avg_km && <li>{c.avg_km} km</li>}
                          {c.duration && <li>{c.duration} mois</li>}
                          {c.budget && <li>{c.budget} €</li>}
                        </ul>
                      </span>
                    </div>
                  )}
              </div>
            );
          });
    let identity='';
    if(this.props.client.name){
      identity = this.props.client.name;
      if(this.props.client.first_name){
        identity += ' '+this.props.client.first_name;
      }
      identity = identity.toLowerCase();
    }
    return (
      <div className='card mr-2 my-3'>
        <div className='card-body informations d-flex flex-column flex-grow-1 overflow-hidden'>
          <div className='card-title'>
            <span className='h4 text-capitalize'>{identity}</span>
            <span className='float-right mb-0'>
              <a
                href='#'
                className=''
                onClick={() => {
                  window.location.href = '/client/edit/' + this.props.client.id;
                }}
              >
                <li className='fas fa-pencil-alt'> </li> <u>Modifier</u>
              </a>
            </span>
          </div>
          <div className="overflow-auto">
            {this.props.client.company && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Entreprise</span>
                <span>{this.props.client.company}</span>
              </div>
            )}

            {this.props.client.siret && this.props.client.siret != '\xa0' && (
              <span className='siretClient' data-toggle='modal' data-target='#siretClient'>
                <span className='h6 text-secondary mr-1'>Siret</span>
                <span className='float-right'>
                  {this.props.client.siret}
                  <span className='ml-1 fas fa-question-circle'></span>
                </span>
                {/* <hr></hr> */}
              </span>
            )}
            <div className='modal fade' id='siretClient' tabIndex='-1' role='dialog' aria-labelledby='#siretClientTitle' aria-hidden='true'>
              <div className='modal-dialog'>
                <div className='modal-content'>
                  <div className='modal-header bg-light'>
                    <span className='modal-title h5' id='siretClientTitle'>
                      {this.props.client.name}
                    </span>
                    <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                      <span aria-hidden='true'>&times;</span>
                    </button>
                  </div>
                  <div className='modal-body text-left'>
                    <div>
                      <span className='text-secondary'>Entreprise</span>
                      <span className='float-right'>
                        {this.props.client.company != null && this.props.client.company != '\xa0' ? this.props.client.company : 'N/A'}
                      </span>
                    </div>
                    {/* {/* <hr></hr> */} */}
                    <div>
                      <span className='h6 text-secondary'>APE</span>
                      <span className='float-right'>
                        {this.props.client.ape != null && this.props.client.ape != '\xa0' ? this.props.client.ape : 'N/A'}
                      </span>
                    </div>
                    {/* <hr></hr> */}
                    <div>
                      <span className='h6 text-secondary'>Type d'activité</span>
                      <span className='float-right'>
                        {this.props.client.activity != null && this.props.client.activity != '\xa0' ? this.props.client.activity : 'N/A'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {this.props.client.address && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Adresse</span>
                <span className='float-right'>{this.props.client.address}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.postal_code && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Code postal</span>
                <span className='float-right'>{this.props.client.postal_code}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.city && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Ville</span>
                <span className='float-right'>{this.props.client.city}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {phone.length > 0 && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Téléphone fixe</span>
                <span className='float-right'>{phone}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {phone_mobile.length > 0 && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Téléphone mobile</span>
                <span className='float-right'>{phone_mobile}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {email.length > 0 && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Adresse(s) Email</span>
                <span className='float-right'>{email}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.birthdate != null && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Date de naissance</span>
                <span className='float-right'>{birthdate}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.birth_address && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Lieu de naissance</span>
                <span className='float-right'>{this.props.client.birth_address}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.gender != null && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Sexe</span>
                <span className='float-right'>
                  {this.props.client.gender === 0 ? 'HOMME' : ''}
                  {this.props.client.gender === 1 ? 'FEMME' : ''}
                  {this.props.client.gender === 2 ? 'NEUTRE' : ''}
                </span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.family && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Situation familiale</span>
                <span className='float-right'>{this.props.client.family}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.dead === 1 && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Décédé</span>
                <span className='float-right'>{this.props.client.dead === 1 ? 'OUI' : ''}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.real_estate && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Immobilier</span>
                <span className='float-right'>{this.props.client.real_estate}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.ze_compatible && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Client ZE compatible</span>
                <span className='float-right'>{this.props.client.ze_compatible === 1 ? 'OUI' : 'NON'}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.profession && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Profession</span>
                <span>{this.props.client.profession}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {social_networks.length > 0 && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Réseaux sociaux</span>
                <span className='float-right'>{social_networks}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.animals && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Animaux possédés</span>
                <span className='float-right'>{this.props.client.animals}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.sports && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Sports</span>
                <span className='float-right'>{this.props.client.sports}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.hobbies && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Loisirs / Activités culturelles</span>
                <span className='float-right'>{this.props.client.hobbies}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.household && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Composition du foyer</span>
                <span className='float-right'>{this.props.household.name}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {children.length > 0 && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Enfants</span>
                <span className='float-right'>{children}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {criterias.length > 0 && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Critères</span>
                <span className='float-right'>{criterias}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {useful_equipements.length > 0 && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Equipements impératifs d'un futur véhicule</span>
                <span className='float-right'>{useful_equipements}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {useless_equipements.length > 0 && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Equipements interdits ou inutiles</span>
                <span className='float-right'>{useless_equipements}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.renault_experience && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Expérience Renault</span>
                <span className='float-right'>{this.props.client.renault_experience}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.avg_km && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Kilométrage moyen annuel</span>
                <span className='float-right'>{this.props.client.avg_km} km</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.renewal && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Périodicité moyenne de renouvellement</span>
                <span className='float-right'>{this.props.client.renewal} mois</span>
                {/* <hr></hr> */}
              </div>
            )}

            {(this.props.client.maintenance_renault == 1 || this.props.client.maintenance_renault == 0) && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Lieu d'entretien</span>
                {this.props.client.maintenance_renault == 1 && <span className='float-right'>Renault</span>}
                {this.props.client.maintenance_renault == 1 && <span className='float-right'>{this.props.client.renault_feedback}</span>}
                {this.props.client.maintenance_renault == 0 && <span className='float-right'>{this.props.client.garage}</span>}
                {this.props.client.maintenance_renault == 0 && <span className='float-right'>{this.props.client.garage_comment}</span>}
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.apv_expectations && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Attentes en matière de SAV</span>
                <span className='float-right'>{this.props.client.apv_expectations}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {this.props.client.apv_funding && (
              <div className=''>
                <span className='h6 text-secondary mr-1'>Habitudes de financement APV</span>
                <span className='float-right'>{this.props.client.apv_funding}</span>
                {/* <hr></hr> */}
              </div>
            )}

            {cars}
          </div>
        </div>
      </div>
    );
  }
}

export default Informations;



// WEBPACK FOOTER //
// ./src/Components/Client/Informations.js